import axios from 'axios';
import { getAuthHeaders } from './userController';

// URL base de la API para empleados
const BASE_URL = 'https://yokomo.api.ikeytechnologies.com/empleados/';

// Obtener todos los empleados
export const fetchEmpleados = async () => {
  try {
    const response = await axios.get(BASE_URL,getAuthHeaders());
    console.log(response.data)
    return response.data;
    
  } catch (error) {
    console.error('Error al obtener los empleados:', error);
    throw error;
  }
};
// Obtener empleados por sucursal
export const fetchEmpleadosPorSucursal = async (sucursalId) => {
  try {
    const response = await axios.get(`${BASE_URL}sucursal/${sucursalId}/`,getAuthHeaders());
    console.log(response.data);
    return response.data;
  } catch (error) {
    console.error(`Error al obtener los empleados de la sucursal ${sucursalId}:`, error);
    throw error;
  }
};

// Obtener un empleado específico
export const fetchEmpleado = async (id) => {
  try {
    const response = await axios.get(`${BASE_URL}${id}/`,getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error('Error al obtener el empleado:', error);
    throw error;
  }
};

export const tomarHuellaEmpleado = async (empleadoId) => {
  try {
    const response = await axios.post(
      `${BASE_URL}${empleadoId}/tomar-huella/`,
      {}, // cuerpo vacío
      getAuthHeaders()
    );

    // Aquí obtienes el ID del comando creado
    const comandoId = response.data.comando_id;
    return comandoId;

  } catch (error) {
    console.error(`Error al tomar huella del empleado ${empleadoId}:`, error);
    throw error;
  }
};

// Crear un nuevo empleado
export const createEmpleado = async (empleadoData) => {
  try {
    const response = await axios.post(BASE_URL, empleadoData ,getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error('Error al crear el empleado:', error);
    throw error;
  }
};

// Actualizar un empleado
export const updateEmpleado = async (id, empleadoData) => {
  try {
    const response = await axios.put(`${BASE_URL}${id}/`, empleadoData,getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error('Error al actualizar el empleado:', error);
    throw error;
  }
};

// Eliminar un empleado
export const deleteEmpleado = async (id) => {
  try {
    const response = await axios.delete(`${BASE_URL}${id}/`,getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error('Error al eliminar el empleado:', error);
    throw error;
  }
};
